export default __webpack_public_path__ + "static/media/fd0f8f70329ae95f.234c5a6b05467bb0cd16992a91da0746.svg";